(function () {
  'use strict';

  var SERVICE_PINCODES = [
    '500001','500002','500003','500004','500006','500007','500008','500009','500010',
    '500011','500012','500013','500014','500015','500016','500017','500018','500019','500020',
    '500024','500025','500029','500030','500032','500033','500034','500035','500036','500037',
    '500038','500039','500040','500041','500042','500043','500044','500045','500046','500047',
    '500048','500049','500050','500051','500052','500053','500054','500055','500056','500057',
    '500058','500059','500060','500061','500062','500063','500064','500065','500066','500067',
    '500068','500069','500070','500072','500073','500074','500075','500076','500077','500078',
    '500079','500080','500081','500082','500083','500084','500085','500086','500087','500088',
    '500089','500090','500091','500092','500093','500094','500095','500096','500097','500098','500100',
    '501203','501218','501301','501359','501401','501403','501503','501504','501506',
    '502001','502032','502300','502301','502319','502325',
    '508116','508252','508284',
    '509216','509228'
  ];

  var lastKnownCart = null;
  var WISHLIST_STORAGE_KEY = 'furnoc_wishlist';

  function formatMoney(cents) {
    return '₹' + Math.round(cents / 100).toLocaleString('en-IN');
  }

  function shopifyRoot() {
    if (window.FURNOC && window.FURNOC.rootUrl) return window.FURNOC.rootUrl;
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function cartAddUrl() {
    if (window.FURNOC && window.FURNOC.cartAddUrl) return window.FURNOC.cartAddUrl;
    return shopifyRoot() + 'cart/add';
  }

  function cartAddJsUrl() {
    return shopifyRoot() + 'cart/add.js';
  }

  function cartPageUrl() {
    return shopifyRoot() + 'cart';
  }

  function parseFetchJson(response) {
    return response.text().then(function (text) {
      var data = {};
      if (text) {
        try { data = JSON.parse(text); } catch (e) {
          throw new Error('Cart request failed - refresh and try again');
        }
      }
      if (!response.ok) throw new Error(data.description || data.message || 'Could not update cart');
      return data;
    });
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (char) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[char];
    });
  }

  function readWishlist() {
    try {
      var saved = JSON.parse(localStorage.getItem(WISHLIST_STORAGE_KEY) || '[]');
      return Array.isArray(saved) ? saved : [];
    } catch (err) {
      return [];
    }
  }

  function updateWishlistCount(count) {
    var total = typeof count === 'number' ? count : readWishlist().length;
    document.querySelectorAll('.furnoc-wishlist-count').forEach(function (badge) {
      badge.textContent = total;
      badge.hidden = total <= 0;
      if (total > 0) badge.removeAttribute('hidden');
    });
  }

  function writeWishlist(items) {
    try {
      localStorage.setItem(WISHLIST_STORAGE_KEY, JSON.stringify(items));
    } catch (err) {}
    updateWishlistCount(items.length);
  }

  function isWishlistSaved(items, id) {
    return items.some(function (item) { return String(item.id) === String(id); });
  }

  function setWishlistButtonState(button, saved) {
    if (!button) return;
    button.classList.toggle('is-saved', saved);
    button.setAttribute('aria-pressed', saved ? 'true' : 'false');
    button.setAttribute('aria-label', saved ? 'Remove from wishlist' : 'Save to wishlist');
  }

  function renderWishlistDrawer() {
    var list = document.getElementById('FurnocWishlistItems');
    if (!list) return;

    var items = readWishlist();
    updateWishlistCount(items.length);

    if (!items.length) {
      list.innerHTML =
        '<div class="furnoc-wishlist-drawer__empty">' +
          '<span aria-hidden="true">♥</span>' +
          '<p>Your wishlist is empty</p>' +
          '<small>Save Furnoc modules you want to compare later.</small>' +
        '</div>';
      return;
    }

    list.innerHTML = items.map(function (item) {
      var url = item.url || '/collections/wardrobes';
      var image = item.image ?
        '<img src="' + escapeHtml(item.image) + '" alt="">' :
        '<span aria-hidden="true">F</span>';

      return '<div class="furnoc-wishlist-item" data-wishlist-id="' + escapeHtml(item.id) + '">' +
        '<a class="furnoc-wishlist-item__img" href="' + escapeHtml(url) + '">' + image + '</a>' +
        '<div>' +
          '<a class="furnoc-wishlist-item__title" href="' + escapeHtml(url) + '">' + escapeHtml(item.title || 'Furnoc product') + '</a>' +
          (item.price ? '<div class="furnoc-wishlist-item__price">' + escapeHtml(item.price) + '</div>' : '') +
          '<a class="furnoc-wishlist-item__view" href="' + escapeHtml(url) + '">View product</a>' +
        '</div>' +
        '<button type="button" class="furnoc-wishlist-item__remove" data-wishlist-remove="' + escapeHtml(item.id) + '" aria-label="Remove from wishlist">×</button>' +
      '</div>';
    }).join('');

    list.querySelectorAll('[data-wishlist-remove]').forEach(function (button) {
      button.addEventListener('click', function () {
        var id = button.getAttribute('data-wishlist-remove');
        var next = readWishlist().filter(function (item) { return String(item.id) !== String(id); });
        writeWishlist(next);
        document.querySelectorAll('[data-wishlist-btn][data-product-id="' + id + '"]').forEach(function (productButton) {
          setWishlistButtonState(productButton, false);
        });
        renderWishlistDrawer();
        showToast('Removed from wishlist');
      });
    });
  }

  function openWishlist() {
    var drawer = document.getElementById('FurnocWishlistDrawer');
    var overlay = document.getElementById('FurnocWishlistOverlay');
    if (!drawer) return;
    closeCart();
    renderWishlistDrawer();
    drawer.classList.add('is-open');
    if (overlay) { overlay.hidden = false; overlay.removeAttribute('hidden'); }
    document.body.classList.add('furnoc-cart-open');
  }

  function closeWishlist() {
    var drawer = document.getElementById('FurnocWishlistDrawer');
    var overlay = document.getElementById('FurnocWishlistOverlay');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    if (overlay) overlay.hidden = true;
    document.body.classList.remove('furnoc-cart-open');
  }

  function showToast(text, type) {
    var el = document.getElementById('FurnocCartMessage');
    if (!el) {
      el = document.createElement('div');
      el.id = 'FurnocCartMessage';
      el.className = 'furnoc-cart-message';
      document.body.appendChild(el);
    }
    el.textContent = text;
    el.className = 'furnoc-cart-message furnoc-cart-message--' + (type || 'error');
    el.hidden = false;
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.hidden = true; }, 4000);
  }

  function updateCartCount(n) {
    var badge = document.getElementById('FurnocCartCount');
    if (!badge) return;
    badge.textContent = n;
    badge.hidden = n <= 0;
    if (n > 0) badge.removeAttribute('hidden');
  }

  function buildQtyStepperHtml(key, qty) {
    return '<div class="furnoc-qty-stepper" data-key="' + key + '" data-qty="' + qty + '">' +
      '<button type="button" class="furnoc-qty-btn" data-delta="-1" aria-label="Decrease quantity">−</button>' +
      '<span class="furnoc-qty-value">' + qty + '</span>' +
      '<button type="button" class="furnoc-qty-btn" data-delta="1" aria-label="Increase quantity">+</button>' +
    '</div>';
  }

  function buildItemHtml(item) {
    var vt = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
    var price = item.final_line_price || item.line_price || item.price || 0;
    var qty = item.quantity || 1;
    var roomName = item.properties && item.properties['Room Name'] ? String(item.properties['Room Name']).trim() : '';
    var isService = item.product_type === 'Service';
    var roomFieldHtml = isService ? '' :
        '<div class="furnoc-room-field furnoc-room-field--drawer">' +
          '<label for="FurnocDrawerRoom-' + item.key + '">Room name</label>' +
          '<div class="furnoc-room-field__row">' +
            '<input type="text" id="FurnocDrawerRoom-' + item.key + '" class="furnoc-room-input" ' +
              'list="FurnocRoomNameSuggestions" data-key="' + item.key + '" ' +
              'value="' + escapeHtml(roomName) + '" placeholder="e.g. Bedroom or Kitchen 1">' +
            '<button type="button" class="furnoc-room-save" data-key="' + item.key + '">Save</button>' +
          '</div>' +
          '<p class="furnoc-room-status"></p>' +
        '</div>';
    return '<div class="furnoc-cart-item" data-key="' + item.key + '">' +
      '<div class="furnoc-cart-item__img">' + (item.image ? '<img src="' + item.image + '" alt="">' : '📦') + '</div>' +
      '<div class="furnoc-cart-item__body">' +
        '<div class="furnoc-cart-item__name">' + escapeHtml(item.product_title || item.title || '') + '</div>' +
        (vt ? '<div class="furnoc-cart-item__variant">' + escapeHtml(vt) + '</div>' : '') +
        roomFieldHtml +
        '<div class="furnoc-cart-item__price">' + formatMoney(price) + '</div>' +
        buildQtyStepperHtml(item.key, qty) +
      '</div>' +
      '<button type="button" class="furnoc-cart-item__remove" data-key="' + item.key + '" aria-label="Remove">×</button>' +
    '</div>';
  }

  function changeCartQuantity(key, quantity) {
    return fetch(shopifyRoot() + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(parseFetchJson);
  }

  function readCartRowProperties(row) {
    if (!row) return {};
    try {
      var parsed = JSON.parse(row.getAttribute('data-properties') || '{}') || {};
      var properties = {};

      if (Array.isArray(parsed)) {
        parsed.forEach(function (item) {
          if (Array.isArray(item) && item.length >= 2) {
            properties[item[0]] = item[1];
          } else if (item && typeof item === 'object') {
            var key = item.name || item.key || item[0];
            var value = item.value || item[1];
            if (key) properties[key] = value;
          }
        });
        return properties;
      }

      return parsed;
    } catch (e) {
      return {};
    }
  }

  function readDrawerItemProperties(key) {
    if (!lastKnownCart || !lastKnownCart.items) return {};
    var match = lastKnownCart.items.filter(function (i) { return String(i.key) === String(key); })[0];
    if (!match || !match.properties) return {};
    var properties = {};
    Object.keys(match.properties).forEach(function (k) {
      if (match.properties[k] !== null && match.properties[k] !== '') properties[k] = match.properties[k];
    });
    return properties;
  }

  function changeCartProperties(key, properties) {
    return fetch(shopifyRoot() + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: key, properties: properties })
    }).then(parseFetchJson);
  }

  function collectRoomNames(cart) {
    var seen = {};
    var rooms = [];
    if (!cart || !cart.items) return rooms;

    cart.items.forEach(function (item) {
      var value = item.properties && item.properties['Room Name'] ? String(item.properties['Room Name']).trim() : '';
      var key = value.toLowerCase();
      if (!value || seen[key]) return;
      seen[key] = true;
      rooms.push(value);
    });

    return rooms.sort(function (a, b) {
      return a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' });
    });
  }

  function updateRoomNameSuggestions(cart) {
    var datalists = document.querySelectorAll('#FurnocRoomNameSuggestions');
    if (!datalists.length) return;

    var rooms = collectRoomNames(cart);

    datalists.forEach(function (datalist) {
      datalist.innerHTML = '';
      rooms.forEach(function (room) {
        var option = document.createElement('option');
        option.value = room;
        datalist.appendChild(option);
      });
    });

    var field = document.getElementById('FurnocRoomName');
    if (field) field.setAttribute('placeholder', rooms.length ? 'Choose room or type new room' : 'e.g. Bedroom or Kitchen 1');
  }

  function getCartRowRoomName(row) {
    var input = row ? row.querySelector('.furnoc-room-input') : null;
    if (input && input.value && input.value.trim()) return input.value.trim();
    var properties = readCartRowProperties(row);
    return properties['Room Name'] ? String(properties['Room Name']).trim() : '';
  }

  function groupCartPageByRoom(list) {
    if (!list) return;
    var rows = Array.prototype.slice.call(list.querySelectorAll('.furnoc-cart-row'));
    if (!rows.length) return;

    var groups = {};
    rows.forEach(function (row, index) {
      if (!row.dataset.originalIndex) row.dataset.originalIndex = String(index);
      var roomName = getCartRowRoomName(row);
      var groupName = roomName || 'Room not assigned';
      if (!groups[groupName]) groups[groupName] = [];
      groups[groupName].push(row);
    });

    var roomNames = Object.keys(groups).sort(function (a, b) {
      if (a === 'Room not assigned') return 1;
      if (b === 'Room not assigned') return -1;
      return a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' });
    });

    list.innerHTML = '';
    list.classList.add('is-room-grouped');

    roomNames.forEach(function (roomName) {
      var group = document.createElement('section');
      group.className = 'furnoc-cart-room-group';
      group.setAttribute('data-room-group', roomName);

      var heading = document.createElement('div');
      heading.className = 'furnoc-cart-room-group__heading';

      var title = document.createElement('h2');
      title.textContent = roomName;

      var count = document.createElement('span');
      count.textContent = groups[roomName].length + (groups[roomName].length === 1 ? ' item' : ' items');

      heading.appendChild(title);
      heading.appendChild(count);
      group.appendChild(heading);

      groups[roomName]
        .sort(function (a, b) {
          return (parseInt(a.dataset.originalIndex, 10) || 0) - (parseInt(b.dataset.originalIndex, 10) || 0);
        })
        .forEach(function (row) {
          group.appendChild(row);
        });

      list.appendChild(group);
    });
  }

  function getDrawerItemRoomName(item) {
    var input = item ? item.querySelector('.furnoc-room-input') : null;
    if (input && input.value && input.value.trim()) return input.value.trim();
    var key = item ? item.getAttribute('data-key') : null;
    var properties = readDrawerItemProperties(key);
    return properties['Room Name'] ? String(properties['Room Name']).trim() : '';
  }

  function groupCartDrawerByRoom() {
    var list = document.getElementById('FurnocCartItems');
    if (!list) return;
    var items = Array.prototype.slice.call(list.querySelectorAll('.furnoc-cart-item'));
    if (!items.length) return;

    var groups = {};
    items.forEach(function (item, index) {
      if (!item.dataset.originalIndex) item.dataset.originalIndex = String(index);
      var roomName = getDrawerItemRoomName(item);
      var groupName = roomName || 'Room not assigned';
      if (!groups[groupName]) groups[groupName] = [];
      groups[groupName].push(item);
    });

    var roomNames = Object.keys(groups).sort(function (a, b) {
      if (a === 'Room not assigned') return 1;
      if (b === 'Room not assigned') return -1;
      return a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' });
    });

    if (roomNames.length === 1 && roomNames[0] === 'Room not assigned') {
      list.classList.remove('is-room-grouped');
      return;
    }

    list.classList.add('is-room-grouped');
    var fragment = document.createDocumentFragment();

    roomNames.forEach(function (roomName) {
      var group = document.createElement('section');
      group.className = 'furnoc-cart-drawer-room-group';
      group.setAttribute('data-room-group', roomName);

      var heading = document.createElement('div');
      heading.className = 'furnoc-cart-drawer-room-group__heading';

      var title = document.createElement('span');
      title.textContent = roomName;

      var count = document.createElement('span');
      count.textContent = groups[roomName].length + (groups[roomName].length === 1 ? ' item' : ' items');

      heading.appendChild(title);
      heading.appendChild(count);
      group.appendChild(heading);

      groups[roomName]
        .sort(function (a, b) {
          return (parseInt(a.dataset.originalIndex, 10) || 0) - (parseInt(b.dataset.originalIndex, 10) || 0);
        })
        .forEach(function (item) {
          group.appendChild(item);
        });

      fragment.appendChild(group);
    });

    list.innerHTML = '';
    list.appendChild(fragment);
  }

  function bindQtySteppers(container) {
    if (!container) return;
    container.querySelectorAll('.furnoc-qty-stepper').forEach(function (stepper) {
      stepper.querySelectorAll('.furnoc-qty-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var key = stepper.getAttribute('data-key');
          var current = parseInt(stepper.getAttribute('data-qty'), 10) || 1;
          var delta = parseInt(btn.getAttribute('data-delta'), 10);
          var next = current + delta;
          if (next < 0) next = 0;
          stepper.classList.add('is-loading');
          changeCartQuantity(key, next).then(function () {
            if (document.getElementById('FurnocCartPageList')) {
              window.location.reload();
            } else {
              return refreshCart();
            }
          }).catch(function (err) {
            showToast(err.message);
            stepper.classList.remove('is-loading');
          });
        });
      });
    });
  }

  function bindRemoveButtons(container) {
    if (!container) return;
    container.querySelectorAll('.furnoc-cart-item__remove, .furnoc-cart-row__remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-key');
        changeCartQuantity(key, 0).then(function () {
          if (document.getElementById('FurnocCartPageList')) {
            window.location.reload();
          } else {
            return refreshCart();
          }
        }).catch(function (err) { showToast(err.message); });
      });
    });
  }

  function saveRoomNameInput(input) {
    var key = input.getAttribute('data-key');
    var row = input.closest('.furnoc-cart-row');
    var item = input.closest('.furnoc-cart-item');
    var status = (row || item) ? (row || item).querySelector('.furnoc-room-status') : null;
    var properties = row ? readCartRowProperties(row) : readDrawerItemProperties(key);
    var value = (input.value || '').trim();

    if (!key) return Promise.resolve();
    if (value) properties['Room Name'] = value;
    else delete properties['Room Name'];

    input.classList.add('is-saving');
    input.setAttribute('aria-busy', 'true');
    if (status) {
      status.textContent = 'Saving room name...';
      status.classList.remove('is-error');
    }

    return changeCartProperties(key, properties).then(function (cart) {
      if (row) row.setAttribute('data-properties', JSON.stringify(properties));
      input.dataset.savedValue = value;
      input.classList.remove('is-dirty');
      input.classList.remove('is-error');
      if (status) status.textContent = value ? 'Saved for checkout and order details.' : 'Room name cleared.';
      if (row) {
        groupCartPageByRoom(document.getElementById('FurnocCartPageList'));
      } else {
        lastKnownCart = cart;
        groupCartDrawerByRoom();
      }
      return cart;
    }).catch(function (err) {
      input.classList.add('is-dirty');
      if (status) {
        status.textContent = err.message || 'Could not save room name. Try again.';
        status.classList.add('is-error');
      }
      showToast(err.message || 'Could not save room name');
      throw err;
    }).finally(function () {
      input.classList.remove('is-saving');
      input.removeAttribute('aria-busy');
    });
  }

  function bindRoomNameInputs(container) {
    if (!container) return;

    container.querySelectorAll('.furnoc-room-input').forEach(function (input) {
      if (input.dataset.roomBound) return;
      input.dataset.roomBound = 'true';
      input.dataset.savedValue = (input.value || '').trim();

      input.addEventListener('input', function () {
        input.classList.remove('is-error');
        var dirty = (input.value || '').trim() !== (input.dataset.savedValue || '');
        input.classList.toggle('is-dirty', dirty);
        var row = input.closest('.furnoc-cart-row') || input.closest('.furnoc-cart-item');
        var status = row ? row.querySelector('.furnoc-room-status') : null;
        if (status && dirty) {
          status.textContent = 'Unsaved room name. Press Save or checkout to apply.';
          status.classList.remove('is-error');
        }
      });
    });

    container.querySelectorAll('.furnoc-room-save').forEach(function (button) {
      if (button.dataset.roomBound) return;
      button.dataset.roomBound = 'true';
      button.addEventListener('click', function () {
        var row = button.closest('.furnoc-cart-row') || button.closest('.furnoc-cart-item');
        var input = row ? row.querySelector('.furnoc-room-input') : null;
        if (input) saveRoomNameInput(input).catch(function () {});
      });
    });
  }

  function initCheckoutRoomGate() {
    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-checkout-button]');
      if (!button) return;

      var allInputs = Array.prototype.slice.call(document.querySelectorAll('.furnoc-room-input'));
      var emptyInputs = allInputs.filter(function (input) { return !(input.value || '').trim(); });

      if (emptyInputs.length) {
        event.preventDefault();
        showRoomNameRequiredError(emptyInputs);
        return;
      }

      var dirtyInputs = allInputs.filter(function (input) { return input.classList.contains('is-dirty'); });
      if (!dirtyInputs.length) return;

      event.preventDefault();
      var href = button.getAttribute('href') || '/checkout';
      button.classList.add('is-loading');
      button.textContent = 'Saving checkout details...';

      Promise.all(dirtyInputs.map(saveRoomNameInput)).then(function () {
        window.location.href = href;
      }).catch(function () {
        button.classList.remove('is-loading');
        button.textContent = 'Checkout →';
      });
    });
  }

  function showRoomNameRequiredError(emptyInputs) {
    showToast('Please add a room name for every item before checkout.');
    emptyInputs.forEach(function (input) {
      var holder = input.closest('.furnoc-cart-row') || input.closest('.furnoc-cart-item');
      var status = holder ? holder.querySelector('.furnoc-room-status') : null;
      if (status) {
        status.textContent = 'Room name required before checkout.';
        status.classList.add('is-error');
      }
      input.classList.add('is-error');
    });
    var firstHolder = emptyInputs[0].closest('.furnoc-cart-row') || emptyInputs[0].closest('.furnoc-cart-item');
    if (firstHolder && firstHolder.scrollIntoView) {
      firstHolder.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    emptyInputs[0].focus();
  }

  function getInstallBands() {
    return (window.FURNOC && window.FURNOC.installBands) || [];
  }

  function isServiceItem(item) {
    return item.product_type === 'Service';
  }

  function computeCumulativeArea(cart) {
    if (!cart || !cart.items) return 0;
    var total = 0;
    cart.items.forEach(function (item) {
      if (isServiceItem(item)) return;
      var area = parseFloat(item.properties && item.properties['_install_area']);
      if (!area || area <= 0) return;
      total += area * (item.quantity || 1);
    });
    return total;
  }

  function findBandForArea(area, bands) {
    for (var i = 0; i < bands.length; i++) {
      var b = bands[i];
      if (area >= b.min && area < b.max) return b;
    }
    return null;
  }

  function findInstallLineItem(cart) {
    if (!cart || !cart.items) return null;
    for (var i = 0; i < cart.items.length; i++) {
      if (isServiceItem(cart.items[i])) return cart.items[i];
    }
    return null;
  }

  var installRecommendCardIds = [
    { root: 'FurnocInstallRecommend', detail: 'FurnocInstallRecommendDetail', price: 'FurnocInstallRecommendPrice', btn: 'FurnocInstallRecommendBtn' },
    { root: 'FurnocCartPageInstallRecommend', detail: 'FurnocCartPageInstallRecommendDetail', price: 'FurnocCartPageInstallRecommendPrice', btn: 'FurnocCartPageInstallRecommendBtn' }
  ];

  var installSyncInFlight = false;

  function renderInstallRecommend(cart) {
    var bands = getInstallBands();
    var area = computeCumulativeArea(cart);
    var existing = findInstallLineItem(cart);

    var cards = installRecommendCardIds.map(function (ids) {
      return {
        root: document.getElementById(ids.root),
        detail: document.getElementById(ids.detail),
        price: document.getElementById(ids.price),
        btn: document.getElementById(ids.btn)
      };
    });

    if (!area || area <= 0 || !bands.length) {
      cards.forEach(function (c) { if (c.root) c.root.hidden = true; });
      if (existing && !installSyncInFlight) {
        installSyncInFlight = true;
        changeCartQuantity(existing.key, 0).then(function () { return refreshCart(); }).catch(function () {}).finally(function () { installSyncInFlight = false; });
      }
      return;
    }

    var band = findBandForArea(area, bands);
    if (!band) {
      cards.forEach(function (c) { if (c.root) c.root.hidden = true; });
      return;
    }

    var qty = Math.ceil(area);
    var total = qty * band.rate;
    var cabinetCount = 0;
    cart.items.forEach(function (item) { if (!isServiceItem(item)) cabinetCount += (item.quantity || 0); });

    var isAdded = !!(existing && String(existing.variant_id) === String(band.id) && existing.quantity === qty);
    var needsSync = !!(existing && !isAdded);

    cards.forEach(function (c) {
      if (!c.root) return;
      c.root.hidden = false;
      if (c.detail) c.detail.textContent = 'Across ' + cabinetCount + ' item' + (cabinetCount === 1 ? '' : 's');
      if (c.price) c.price.textContent = formatMoney(total);
      if (c.btn) {
        c.btn.textContent = isAdded ? '✓ Added' : 'Add';
        c.btn.classList.toggle('is-added', isAdded);
      }
    });

    if (needsSync && !installSyncInFlight) {
      installSyncInFlight = true;
      var syncPromise;
      if (String(existing.variant_id) === String(band.id)) {
        syncPromise = changeCartQuantity(existing.key, qty);
      } else {
        syncPromise = changeCartQuantity(existing.key, 0).then(function () {
          return addInstallationToCart(band.id, qty);
        });
      }
      syncPromise.then(function () { return refreshCart(); }).catch(function () {}).finally(function () { installSyncInFlight = false; });
    }
  }

  function initInstallRecommend() {
    installRecommendCardIds.forEach(function (ids) {
      var btn = document.getElementById(ids.btn);
      if (!btn) return;
      btn.addEventListener('click', function () {
        var cart = lastKnownCart;
        if (!cart) return;
        var bands = getInstallBands();
        var area = computeCumulativeArea(cart);
        var band = findBandForArea(area, bands);
        if (!band) return;
        var qty = Math.ceil(area);
        var existing = findInstallLineItem(cart);

        if (existing && String(existing.variant_id) === String(band.id) && existing.quantity === qty) {
          changeCartQuantity(existing.key, 0).then(function () { return refreshCart(); }).catch(function (err) { showToast(err.message); });
        } else {
          addInstallationToCart(band.id, qty).then(function () { return refreshCart(); }).catch(function () {});
        }
      });
    });
  }

  function renderCart(cart, opts) {
    opts = opts || {};
    lastKnownCart = cart;
    updateCartCount(cart.item_count);
    renderInstallRecommend(cart);
    var itemsEl = document.getElementById('FurnocCartItems');
    var footerEl = document.getElementById('FurnocCartFooter');
    var subtotalEl = document.getElementById('FurnocCartSubtotal');
    if (!itemsEl || !footerEl) return;
    if (!cart.items || !cart.items.length) {
      if (opts.preserveDrawerItems && itemsEl.querySelector('.furnoc-cart-item')) return;
      itemsEl.innerHTML = '<div class="furnoc-cart-drawer__empty"><span class="furnoc-cart-drawer__empty-icon">🛒</span><p>Your cart is empty</p></div>';
      footerEl.hidden = true;
      return;
    }
    footerEl.hidden = false;
    footerEl.removeAttribute('hidden');
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    itemsEl.innerHTML = cart.items.map(buildItemHtml).join('');
    bindRemoveButtons(itemsEl);
    bindQtySteppers(itemsEl);
    bindRoomNameInputs(itemsEl);
    groupCartDrawerByRoom();
  }

  function refreshCart(opts) {
    opts = opts || {};
    return fetch(shopifyRoot() + 'cart.js', {
      credentials: 'same-origin', headers: { Accept: 'application/json' }
    }).then(parseFetchJson).then(function (cart) {
      renderCart(cart, opts);
      updateRoomNameSuggestions(cart);
      return cart;
    });
  }

  function openCart(skipRefresh) {
    var drawer = document.getElementById('FurnocCartDrawer');
    var overlay = document.getElementById('FurnocCartOverlay');
    if (!drawer) return;
    closeWishlist();
    drawer.classList.add('is-open');
    if (overlay) { overlay.hidden = false; overlay.removeAttribute('hidden'); }
    document.body.classList.add('furnoc-cart-open');
    if (!skipRefresh) refreshCart();
  }

  function closeCart() {
    var drawer = document.getElementById('FurnocCartDrawer');
    var overlay = document.getElementById('FurnocCartOverlay');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    if (overlay) overlay.hidden = true;
    document.body.classList.remove('furnoc-cart-open');
  }

  var PINCODE_GATE_STORAGE_KEY = 'furnoc_pincode_gate_passed';
  var pincodeGatePendingProceed = null;

  function pincodeGateEnabled() {
    return !!(window.FURNOC && window.FURNOC.pincodeGateEnabled);
  }

  function hasPassedPincodeGate() {
    try { return localStorage.getItem(PINCODE_GATE_STORAGE_KEY) === '1'; } catch (e) { return true; }
  }

  function markPincodeGatePassed() {
    try { localStorage.setItem(PINCODE_GATE_STORAGE_KEY, '1'); } catch (e) {}
  }

  function initPincodeGate() {
    var modal = document.getElementById('FurnocPincodeGate');
    if (!modal) return;

    var overlay = document.getElementById('FurnocPincodeGateOverlay');
    var closeBtn = document.getElementById('FurnocPincodeGateClose');
    var input = document.getElementById('FurnocPincodeGateInput');
    var checkBtn = document.getElementById('FurnocPincodeGateCheck');
    var result = document.getElementById('FurnocPincodeGateResult');

    function resolveAndClose() {
      modal.hidden = true;
      document.body.classList.remove('furnoc-pincode-gate-open');
      var proceed = pincodeGatePendingProceed;
      pincodeGatePendingProceed = null;
      if (proceed) proceed();
    }

    function dismissWithoutProceeding() {
      modal.hidden = true;
      document.body.classList.remove('furnoc-pincode-gate-open');
      pincodeGatePendingProceed = null;
    }

    function check() {
      var v = (input.value || '').replace(/\D/g, '').slice(0, 6);
      input.value = v;
      result.className = 'furnoc-pincode-gate__result';
      if (v.length < 6) { result.textContent = ''; return; }

      if (SERVICE_PINCODES.indexOf(v) >= 0) {
        result.classList.add('is-ok');
        result.textContent = '✓ One-day delivery available! Adding to cart...';
        markPincodeGatePassed();
        setTimeout(resolveAndClose, 600);
      } else {
        result.classList.add('is-no');
        var waNumber = (window.FURNOC && window.FURNOC.whatsappNumber) || '';
        var waText = encodeURIComponent('Hi Furnoc! My pincode is ' + v + ' - are there any delivery possibilities here?');
        var html = '✗ Not in our service area yet.';
        if (waNumber) {
          html += ' <a href="https://wa.me/' + waNumber + '?text=' + waText + '" target="_blank" rel="noopener" class="furnoc-btn furnoc-btn--whatsapp furnoc-btn--sm">💬 Check Delivery Possibilities</a>';
        }
        html += ' <button type="button" class="furnoc-btn furnoc-btn--primary furnoc-btn--sm" id="FurnocPincodeGateContinue">Continue to Cart</button>';
        result.innerHTML = html;

        var continueBtn = document.getElementById('FurnocPincodeGateContinue');
        if (continueBtn) {
          continueBtn.addEventListener('click', function () {
            markPincodeGatePassed();
            resolveAndClose();
          });
        }
      }
    }

    if (checkBtn) checkBtn.addEventListener('click', check);
    if (input) input.addEventListener('keyup', function (e) { if (e.key === 'Enter') check(); });
    if (closeBtn) closeBtn.addEventListener('click', dismissWithoutProceeding);
    if (overlay) overlay.addEventListener('click', dismissWithoutProceeding);
  }

  function showPincodeGate(onProceed) {
    var modal = document.getElementById('FurnocPincodeGate');
    if (!modal) { onProceed(); return; }

    var input = document.getElementById('FurnocPincodeGateInput');
    var result = document.getElementById('FurnocPincodeGateResult');
    if (input) input.value = '';
    if (result) { result.textContent = ''; result.className = 'furnoc-pincode-gate__result'; }

    pincodeGatePendingProceed = onProceed;
    modal.hidden = false;
    document.body.classList.add('furnoc-pincode-gate-open');
    if (input) input.focus();
  }

  function handleAddToCart(variantId, btn, form, extraProperties) {
    if (pincodeGateEnabled() && !hasPassedPincodeGate()) {
      return new Promise(function (resolve, reject) {
        showPincodeGate(function () {
          performAddToCart(variantId, btn, form, extraProperties).then(resolve, reject);
        });
      });
    }
    return performAddToCart(variantId, btn, form, extraProperties);
  }

  function performAddToCart(variantId, btn, form, extraProperties) {
    var id = parseInt(String(variantId), 10);
    if (!id) { showToast('Please select all options'); return Promise.resolve(); }

    var origText = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }

    function postAdd() {
      if (form) {
        var fd = new FormData(form);
        if (!fd.get('quantity')) fd.set('quantity', '1');
        return fetch(cartAddUrl(), {
          method: 'POST',
          credentials: 'same-origin',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: fd
        }).then(parseFetchJson);
      }
      return fetch(cartAddJsUrl(), {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: id, quantity: 1, properties: extraProperties || {} })
      }).then(parseFetchJson);
    }

    return postAdd().then(function () {
      return refreshCart({ preserveDrawerItems: true });
    }).then(function (cart) {
      if (!cart || !cart.item_count) {
        throw new Error('Item not added - check stock and Online Store channel');
      }
      return cart;
    }).catch(function (err) {
      var msg = err.message || 'Could not add to cart';
      showToast(msg);
      if (form && !/sold out|out of stock|inventory/i.test(msg)) {
        form.removeEventListener('submit', form._furnocSubmit);
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.submit();
      }
      throw err;
    }).finally(function () {
      if (btn) { btn.innerHTML = origText; btn.disabled = false; }
    });
  }

  function addInstallationToCart(variantId, quantity) {
    var id = parseInt(String(variantId), 10);
    if (!id) return Promise.resolve();

    return fetch(cartAddJsUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: id, quantity: quantity || 1 })
    }).then(parseFetchJson).catch(function (err) {
      showToast('Item added, but installation could not be added - please add it separately.');
      throw err;
    });
  }

  function initProductPage() {
    var form = document.getElementById('FurnocProductForm');
    if (!form) return;

    var variantDataEl = document.getElementById('FurnocVariantData');
    if (!variantDataEl) return;

    var variants = [];
    try { variants = JSON.parse(variantDataEl.textContent); } catch (e) { return; }

    var variantAreaData = {};
    var areaDataEl = document.getElementById('FurnocVariantAreaData');
    if (areaDataEl) { try { variantAreaData = JSON.parse(areaDataEl.textContent) || {}; } catch (e) {} }

    function syncInstallAreaProperty(variantId) {
      var prop = document.getElementById('FurnocInstallAreaProp');
      if (!prop) return;
      var area = variantAreaData[String(variantId)];
      prop.value = (area !== undefined && area !== null) ? area : 0;
    }

    var groups = form.querySelectorAll('.furnoc-option-group');
    var numOptions = groups.length;
    var selectedOptions = [];

    groups.forEach(function (group, i) {
      var active = group.querySelector('.is-active');
      var select = group.querySelector('.furnoc-hardware-select');
      if (select) {
        selectedOptions[i] = select.value || '';
      } else if (active) {
        selectedOptions[i] = active.getAttribute('data-value') || '';
      } else {
        selectedOptions[i] = '';
      }
    });

    function findVariant() {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i]; var ok = true;
        for (var j = 0; j < numOptions; j++) {
          if (selectedOptions[j] && v['option' + (j + 1)] !== selectedOptions[j]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    function findVariantWithOverride(optionIndex, value) {
      var testOptions = selectedOptions.slice();
      testOptions[optionIndex] = value;
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i]; var ok = true;
        for (var j = 0; j < numOptions; j++) {
          if (testOptions[j] && v['option' + (j + 1)] !== testOptions[j]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    function renderDeltas() {
      for (var i = 0; i < numOptions; i++) {
        var group = groups[i];
        if (!group) continue;
        var deltaEls = group.querySelectorAll('.furnoc-pill-delta[data-option-index="' + i + '"], .furnoc-swatch-delta[data-option-index="' + i + '"]');
        if (!deltaEls.length) continue;

        var candidates = [];
        deltaEls.forEach(function (el) {
          var val = el.getAttribute('data-value');
          var match = findVariantWithOverride(i, val);
          if (match) candidates.push({ el: el, price: match.price });
        });
        if (!candidates.length) continue;

        var minPrice = candidates.reduce(function (min, c) { return Math.min(min, c.price); }, candidates[0].price);
        candidates.forEach(function (c) {
          var diff = c.price - minPrice;
          if (diff === 0) {
            c.el.textContent = '';
          } else {
            c.el.textContent = (diff > 0 ? '+' : '−') + formatMoney(Math.abs(diff));
          }
        });
      }
    }

    function syncMainImage(v) {
      if (!v || !v.featured_image || !v.featured_image.src) return;

      document.querySelectorAll('.furnoc-product-detail__model-wrap').forEach(function (wrap) { wrap.hidden = true; });

      var mainImg = document.getElementById('FurnocMainImg');
      if (!mainImg) return;

      if (mainImg.tagName === 'IMG') {
        mainImg.hidden = false;
        mainImg.removeAttribute('srcset');
        mainImg.removeAttribute('sizes');
        mainImg.src = v.featured_image.src;
      } else {
        var img = document.createElement('img');
        img.id = 'FurnocMainImg';
        img.className = 'furnoc-product-detail__main-img';
        img.src = v.featured_image.src;
        img.alt = '';
        mainImg.replaceWith(img);
      }

      document.querySelectorAll('.furnoc-img-tab').forEach(function (t) { t.classList.remove('is-active'); });
      var matchingTab = document.querySelector('.furnoc-img-tab[data-src="' + v.featured_image.src + '"]');
      if (matchingTab) matchingTab.classList.add('is-active');
    }

    function updatePage(v) {
      if (!v) return;

      var hiddenId = document.getElementById('FurnocVariantId');
      if (hiddenId) hiddenId.value = v.id;

      syncMainImage(v);

      var priceEl = document.getElementById('FurnocPrice');
      if (priceEl) priceEl.textContent = formatMoney(v.price);

      var emiEl = document.getElementById('FurnocEmi');
      if (emiEl) emiEl.textContent = 'From ' + formatMoney(Math.round(v.price / 12)) + '/month · 0% EMI on select cards';

      var compareEl = document.getElementById('FurnocCompare');
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.textContent = formatMoney(v.compare_at_price);
          compareEl.style.display = 'inline';
        } else {
          compareEl.style.display = 'none';
        }
      }

      var addBtn = document.getElementById('FurnocAddToCart');
      var btnPrice = document.getElementById('FurnocBtnPrice');

      var stockEl = document.getElementById('FurnocStock');
      if (stockEl) {
        if (!v.available) {
          stockEl.innerHTML = '<span class="furnoc-stock-out">✗ Out of Stock</span>';
          if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Out of Stock'; }
        } else {
          if (v.inventory_quantity > 0 && v.inventory_quantity <= 10) {
            stockEl.innerHTML = '<span class="furnoc-stock-low">⚡ Only ' + v.inventory_quantity + ' units left in stock</span>';
          } else {
            stockEl.innerHTML = '<span class="furnoc-stock-in">✓ In Stock</span>';
          }
          if (addBtn) {
            addBtn.disabled = false;
            addBtn.innerHTML = '🛒 Add to Cart · <span id="FurnocBtnPrice">' + formatMoney(v.price) + '</span>';
          }
        }
      }

      renderDeltas();
      syncInstallAreaProperty(v.id);
    }

    form.querySelectorAll('.furnoc-pill').forEach(function (pill) {
      pill.addEventListener('click', function () {
        var group = this.closest('.furnoc-option-group');
        var idx = parseInt(group.getAttribute('data-option-index'));
        var val = this.getAttribute('data-value');
        selectedOptions[idx] = val;
        group.querySelectorAll('.furnoc-pill').forEach(function (p) { p.classList.remove('is-active'); });
        this.classList.add('is-active');
        var lbl = document.getElementById('FurnocSelected' + idx);
        if (lbl) lbl.textContent = val;
        updatePage(findVariant());
      });
    });

    form.querySelectorAll('.furnoc-swatch').forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        var group = this.closest('.furnoc-option-group');
        var idx = parseInt(group.getAttribute('data-option-index'));
        var val = this.getAttribute('data-value');
        selectedOptions[idx] = val;
        group.querySelectorAll('.furnoc-swatch').forEach(function (s) { s.classList.remove('is-active'); });
        this.classList.add('is-active');
        var lbl = document.getElementById('FurnocSelected' + idx);
        if (lbl) lbl.textContent = val;
        updatePage(findVariant());
      });
    });

    form.querySelectorAll('.furnoc-hardware-select').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var idx = parseInt(this.getAttribute('data-option-index'));
        var val = this.value;
        selectedOptions[idx] = val;
        var lbl = document.getElementById('FurnocSelected' + idx);
        if (lbl) lbl.textContent = val;
        var infoEl = document.getElementById('FurnocHardwareInfo');
        if (infoEl) {
          infoEl.querySelectorAll('.furnoc-hw-detail').forEach(function (d) {
            d.classList.toggle('is-active', d.getAttribute('data-hw') === val);
          });
        }
        updatePage(findVariant());
      });
    });

    form._furnocSubmit = function (e) {
      e.preventDefault();
      var idInput = form.querySelector('[name="id"]');
      var submitBtn = form.querySelector('[type="submit"]');
      if (!idInput || !idInput.value) { showToast('Please select all options'); return; }

      handleAddToCart(idInput.value, submitBtn, form).then(function () {
        window.location.href = cartPageUrl();
      }).catch(function () {
      });
    };
    form.addEventListener('submit', form._furnocSubmit);

    updatePage(findVariant());
  }

  function initImageTabs() {
    var tabs = Array.prototype.slice.call(document.querySelectorAll('.furnoc-img-tab'));
    if (!tabs.length) return;

    function activeIndex() {
      var index = tabs.findIndex(function (tab) { return tab.classList.contains('is-active'); });
      return index < 0 ? 0 : index;
    }

    function showImageTab(index) {
      var mainImg = document.getElementById('FurnocMainImg');
      var allModelWraps = document.querySelectorAll('.furnoc-product-detail__model-wrap');

      if (index < 0) index = tabs.length - 1;
      if (index >= tabs.length) index = 0;

      var tab = tabs[index];
      var modelId = tab.getAttribute('data-media-id');

      if (modelId) {
        allModelWraps.forEach(function (wrap) {
          wrap.hidden = wrap.getAttribute('data-media-id') !== modelId;
        });
        if (mainImg) mainImg.hidden = true;
      } else {
        var src = tab.getAttribute('data-src');
        allModelWraps.forEach(function (wrap) { wrap.hidden = true; });
        if (mainImg) {
          mainImg.hidden = false;
          if (src) {
            mainImg.removeAttribute('srcset');
            mainImg.removeAttribute('sizes');
            mainImg.src = src;
          }
        }
      }

      tabs.forEach(function (item) { item.classList.remove('is-active'); });
      tab.classList.add('is-active');
    }

    // IKEA-style behaviour: on devices with real hover (mouse/trackpad), hovering a
    // thumbnail swaps the main image immediately, just like ikea.com. Touch devices
    // (no true hover) keep tap/swipe. Click always works everywhere as the
    // accessible, keyboard/touch-safe path.
    var hoverCapable = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    var hoverTimer = null;

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        clearTimeout(hoverTimer);
        showImageTab(index);
      });

      if (hoverCapable) {
        tab.addEventListener('mouseenter', function () {
          clearTimeout(hoverTimer);
          // tiny debounce so a fast mouse pass-over doesn't flicker through every thumb
          hoverTimer = setTimeout(function () { showImageTab(index); }, 60);
        });
        tab.addEventListener('mouseleave', function () {
          clearTimeout(hoverTimer);
        });
      }
    });

    document.querySelectorAll('.furnoc-product-detail__main-wrap').forEach(function (wrap) {
      var startX = 0;
      var startY = 0;
      var isTouching = false;

      wrap.addEventListener('touchstart', function (event) {
        if (!event.touches || event.touches.length !== 1) return;
        startX = event.touches[0].clientX;
        startY = event.touches[0].clientY;
        isTouching = true;
      }, { passive: true });

      wrap.addEventListener('touchend', function (event) {
        if (!isTouching || !event.changedTouches || !event.changedTouches.length) return;
        var deltaX = event.changedTouches[0].clientX - startX;
        var deltaY = event.changedTouches[0].clientY - startY;
        isTouching = false;

        if (Math.abs(deltaX) < 45 || Math.abs(deltaX) < Math.abs(deltaY) * 1.15) return;
        showImageTab(activeIndex() + (deltaX < 0 ? 1 : -1));
      }, { passive: true });
    });
  }

  function initSpecTabs() {
    document.querySelectorAll('.furnoc-tab-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var tabId = this.getAttribute('data-tab');
        document.querySelectorAll('.furnoc-tab-btn').forEach(function (b) { b.classList.remove('is-active'); });
        document.querySelectorAll('.furnoc-tab-panel').forEach(function (p) { p.classList.remove('is-active'); });
        this.classList.add('is-active');
        var panel = document.getElementById('tab-' + tabId);
        if (panel) panel.classList.add('is-active');
      });
    });
  }

  function initWishlistButtons() {
    var buttons = document.querySelectorAll('[data-wishlist-btn]');
    var wishlist = readWishlist();
    updateWishlistCount(wishlist.length);
    if (!buttons.length) return;

    buttons.forEach(function (button) {
      var id = button.dataset.productId;
      if (!id) return;

      setWishlistButtonState(button, isWishlistSaved(wishlist, id));

      button.addEventListener('click', function () {
        wishlist = readWishlist();
        var saved = isWishlistSaved(wishlist, id);

        if (saved) {
          wishlist = wishlist.filter(function (item) { return String(item.id) !== String(id); });
          writeWishlist(wishlist);
          document.querySelectorAll('[data-wishlist-btn][data-product-id="' + id + '"]').forEach(function (productButton) {
            setWishlistButtonState(productButton, false);
          });
          renderWishlistDrawer();
          showToast('Removed from wishlist');
          return;
        }

        wishlist.push({
          id: id,
          title: button.dataset.productTitle || document.title,
          url: button.dataset.productUrl || window.location.pathname,
          image: button.dataset.productImage || '',
          price: button.dataset.productPrice || '',
          savedAt: new Date().toISOString()
        });
        writeWishlist(wishlist);
        document.querySelectorAll('[data-wishlist-btn][data-product-id="' + id + '"]').forEach(function (productButton) {
          setWishlistButtonState(productButton, true);
        });
        renderWishlistDrawer();
        showToast('Saved to wishlist', 'success');
      });
    });
  }

  function initWishlistDrawer() {
    document.querySelectorAll('#FurnocWishlistOpen, #FurnocWishlistOpenMobile').forEach(function (btn) {
      btn.addEventListener('click', openWishlist);
    });

    var closeBtn = document.getElementById('FurnocWishlistClose');
    var overlay = document.getElementById('FurnocWishlistOverlay');
    if (closeBtn) closeBtn.addEventListener('click', closeWishlist);
    if (overlay) overlay.addEventListener('click', closeWishlist);

    updateWishlistCount();
    renderWishlistDrawer();
  }

  function initMobileMenu() {
    var toggle = document.querySelector('[data-menu-toggle]');
    var menu = document.getElementById('FurnocMobileMenu');
    if (!toggle || !menu) return;

    function openMenu() {
      menu.removeAttribute('hidden');
      document.body.classList.add('furnoc-menu-open');
      toggle.setAttribute('aria-expanded', 'true');
    }

    function closeMenu() {
      menu.setAttribute('hidden', '');
      document.body.classList.remove('furnoc-menu-open');
      toggle.setAttribute('aria-expanded', 'false');
    }

    toggle.addEventListener('click', function () {
      if (menu.hasAttribute('hidden')) openMenu();
      else closeMenu();
    });

    menu.querySelectorAll('[data-menu-close]').forEach(function (button) {
      button.addEventListener('click', closeMenu);
    });

    menu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', closeMenu);
    });

    var wishlistButton = document.getElementById('FurnocWishlistOpenMobile');
    if (wishlistButton) {
      wishlistButton.addEventListener('click', closeMenu);
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !menu.hasAttribute('hidden')) closeMenu();
    });
  }

  function initHeaderSearchToggle() {
    var toggle = document.getElementById('FurnocSearchToggle');
    var form = document.getElementById('FurnocHeaderSearch');
    if (!toggle || !form) return;

    function setOpen(open) {
      form.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        var input = form.querySelector('input[type="search"]');
        if (input) input.focus();
      }
    }

    toggle.addEventListener('click', function (event) {
      event.stopPropagation();
      setOpen(!form.classList.contains('is-open'));
    });

    document.addEventListener('click', function (event) {
      if (!form.classList.contains('is-open')) return;
      if (form.contains(event.target) || toggle.contains(event.target)) return;
      setOpen(false);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && form.classList.contains('is-open')) setOpen(false);
    });
  }

  function initHeaderDropdowns() {
    var nav = document.querySelector('.furnoc-nav');
    if (!nav) return;

    var items = Array.prototype.slice.call(nav.querySelectorAll('.furnoc-nav-item'));

    function closeAll(except) {
      items.forEach(function (item) {
        if (item === except) return;
        item.classList.remove('is-open');
        var button = item.querySelector('.furnoc-nav__link[aria-haspopup="true"]');
        if (button) button.setAttribute('aria-expanded', 'false');
      });
    }

    items.forEach(function (item) {
      var button = item.querySelector('.furnoc-nav__link[aria-haspopup="true"]');
      if (!button) return;

      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        var willOpen = !item.classList.contains('is-open');
        closeAll(item);
        item.classList.toggle('is-open', willOpen);
        button.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      });
    });

    document.addEventListener('click', function (event) {
      if (!nav.contains(event.target)) closeAll();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeAll();
    });
  }

  function initMegaMenuPreview() {
    // Hovering a category link in the Products mega-menu swaps the left "Furniture on
    // click" panel for that category's photo, with a quick crossfade. Touch devices
    // (no real hover) keep the default text panel untouched — the links still work
    // as plain links either way.
    var hoverCapable = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (!hoverCapable) return;

    var featured = document.getElementById('FurnocMegaFeatured');
    var previewImg = document.getElementById('FurnocMegaPreviewImg');
    var categoryCol = document.getElementById('FurnocMegaCategoryCol');
    if (!featured || !previewImg || !categoryCol) return;

    var links = Array.prototype.slice.call(categoryCol.querySelectorAll('a[data-preview-image]'));
    if (!links.length) return;

    links.forEach(function (link) {
      link.addEventListener('mouseenter', function () {
        previewImg.src = this.getAttribute('data-preview-image');
        previewImg.alt = this.textContent.trim();
        featured.classList.add('is-previewing');
        links.forEach(function (l) { l.classList.remove('is-previewing'); });
        this.classList.add('is-previewing');
      });
    });

    categoryCol.addEventListener('mouseleave', function () {
      featured.classList.remove('is-previewing');
      links.forEach(function (l) { l.classList.remove('is-previewing'); });
    });
  }

  function initPincode() {
    document.querySelectorAll('.furnoc-pincode-bar').forEach(function (bar) {
      var input = bar.querySelector('.furnoc-pincode-input');
      var btn = bar.querySelector('.furnoc-pincode-btn');
      var result = bar.querySelector('.furnoc-pincode-result');
      if (!input || !btn || !result) return;

      function check() {
        var v = (input.value || '').replace(/\\D/g, '').slice(0, 6);
        input.value = v;
        result.className = 'furnoc-pincode-result';
        if (v.length < 6) { result.textContent = ''; return; }
        if (SERVICE_PINCODES.indexOf(v) >= 0) {
          result.classList.add('is-ok');
          result.textContent = '✓ One-day delivery available!';
        } else {
          result.classList.add('is-no');
          var waNumber = (window.FURNOC && window.FURNOC.whatsappNumber) || '';
          var waText = encodeURIComponent('Hi Furnoc! My pincode is ' + v + ' - are there any delivery possibilities here?');
          var msg = '✗ Not in our service area yet.';
          if (waNumber) {
            msg += ' <a href="https://wa.me/' + waNumber + '?text=' + waText + '" target="_blank" rel="noopener" class="furnoc-btn furnoc-btn--whatsapp furnoc-btn--sm furnoc-pincode-result__wa">💬 Check Delivery Possibilities</a>';
          }
          result.innerHTML = msg;
        }
      }

      btn.addEventListener('click', check);
      input.addEventListener('keyup', function (e) { if (e.key === 'Enter') check(); });
    });
  }

  function initCartButtons() {
    document.querySelectorAll('#FurnocCartOpen, #FurnocCartOpenMobile').forEach(function (btn) {
      btn.addEventListener('click', function () {
        window.location.href = cartPageUrl();
      });
    });
    var closeBtn = document.getElementById('FurnocCartClose');
    var overlay = document.getElementById('FurnocCartOverlay');
    var continueBtn = document.getElementById('FurnocCartContinue');
    if (closeBtn) closeBtn.addEventListener('click', closeCart);
    if (overlay) overlay.addEventListener('click', closeCart);
    if (continueBtn) continueBtn.addEventListener('click', closeCart);
  }

  function initCartPage() {
    var list = document.getElementById('FurnocCartPageList');
    if (!list) return;
    bindQtySteppers(list);
    bindRemoveButtons(list);
    bindRoomNameInputs(list);
    groupCartPageByRoom(list);
  }

  function initProductCards() {
    document.querySelectorAll('.furnoc-add-to-cart').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var area = parseFloat(btn.dataset.installArea) || 0;
        handleAddToCart(btn.dataset.variantId, btn, null, { '_install_area': area }).then(function () {
          window.location.href = cartPageUrl();
        }).catch(function () {});
      });
    });
  }

  function init() {
    initMobileMenu();
    initHeaderDropdowns();
    initMegaMenuPreview();
    initHeaderSearchToggle();
    initCartButtons();
    initPincode();
    initPincodeGate();
    initImageTabs();
    initSpecTabs();
    initWishlistDrawer();
    initWishlistButtons();
    initProductPage();
    initProductCards();
    initCartPage();
    initCheckoutRoomGate();
    initInstallRecommend();
    refreshCart().catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
